import '@fontsource/reddit-sans/latin.css'
import '@fontsource/reddit-sans/latin-ext.css'
import { ColorSchemeScript, MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import React from 'react'
import { HashRouter } from 'react-router-dom'
import { OwlbertWebAuthProvider } from './auth/OwlbertWebAuthContext'
import { owlbertWebTheme } from './theme'
import './hosted/hostedPluginBuiltinRegistrations'
import { WebAuthedRoutes } from './WebAuthedRoutes'
import { PostHogPageView } from './analytics/PostHogPageView'

import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/tiptap/styles.css'

export const App: React.FC = () => {
  return (
    <>
      <ColorSchemeScript defaultColorScheme="dark" />
      <MantineProvider theme={owlbertWebTheme} defaultColorScheme="dark">
        <Notifications />
        <OwlbertWebAuthProvider>
          <HashRouter future={{ v7_relativeSplatPath: true }}>
            <PostHogPageView />
            <WebAuthedRoutes />
          </HashRouter>
        </OwlbertWebAuthProvider>
      </MantineProvider>
    </>
  )
}
